import Api from './api';
export async function startPush(signal) {
  const capacitor=window.Capacitor;
  if(Api.user?.role!=='customer'||!capacitor?.isNativePlatform?.()||!capacitor.isPluginAvailable('PushNotifications'))return ()=>{};
  const plugin=capacitor.Plugins.PushNotifications;
  const accountId=Api.user.id;
  const current=()=>!signal?.aborted&&Api.user?.id===accountId;
  if(!(await Api.request('/api/push/config')).enabled)return ()=>{};
  if(!current())return ()=>{};
  const listeners=[];
  const cleanup=()=>Promise.allSettled(listeners.splice(0).map(listener=>listener.remove()));
  signal?.addEventListener('abort',cleanup,{once:true});
  try {
  listeners.push(await plugin.addListener('registration',token=>{if(current())Api.mutate('/api/push/device','POST',{token:token.value}).catch(()=>{});}));
  listeners.push(await plugin.addListener('registrationError',()=>console.warn('Telefon bildirim kaydı tamamlanamadı.')));
  listeners.push(await plugin.addListener('pushNotificationActionPerformed',action=>{
    if(!current())return;
    const id=String(action.notification?.data?.notificationId||'');
    window.location.assign('/orders'+(/^\d+$/.test(id)?'?notification='+id:''));
  }));
  let permission=await plugin.checkPermissions();
  if(!current()){await cleanup();return ()=>{};}
  if(['prompt','prompt-with-rationale'].includes(permission.receive))permission=await plugin.requestPermissions();
  if(current()&&permission.receive==='granted') {await plugin.createChannel({id:'zirve_ready',name:'Hazır dökümler',description:'Teslime hazır yeni dökümleriniz',importance:4,visibility:0,sound:'default'});if(current())await plugin.register();}
  if(!current())await cleanup();
  return cleanup;
  } catch(failure) {await cleanup();throw failure;}
}
